import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function HeroPages({ name }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="relative flex items-center justify-center h-[50vh] p-4 md:p-8">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=2000&q=80"
          alt="Luxury Car"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-slate-800/90 to-slate-900/90"></div>
      </div>

      {/* Back Button - Fixed at top left */}
      <button
        onClick={() => navigate("/")}
        className="absolute top-32 left-6 z-20 inline-flex items-center gap-2 px-5 py-2.5 rounded-full 
                   bg-white/10 hover:bg-white/20 border border-white/20 text-white 
                   backdrop-blur-md transition-all duration-300 md:hidden"
      >
        <i className="fa-solid fa-arrow-left"></i>
        <span>{t("back")}</span>
      </button>

      {/* Content */}
      <div className="w-full max-w-[133rem] grid grid-cols-1 lg:grid-cols-2 gap-8 items-center relative z-10 text-white">
        {/* Left Side (Text Content) */}
        <div className="space-y-4 text-center lg:text-left">
          <h1 className="text-4xl font-bold md:text-6xl">{name}</h1>
          <p className="text-lg text-slate-300">
            <Link to="/" className="text-indigo-400 transition hover:text-indigo-300">
              {t("home")}
            </Link>{" "}
            / {name}
          </p>
        </div>

        {/* Right Side (Optional Illustration / Empty Placeholder) */}
        <div className="hidden lg:block"></div>
      </div>
    </section>
  );
}

export default HeroPages;
